import { render, staticRenderFns } from "./discount-by-range-form.vue?vue&type=template&id=0ffb85b2&"
import script from "./discount-by-range-form.vue?vue&type=script&lang=js&"
export * from "./discount-by-range-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports